var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _rect3, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 290,
    viewBox: "0 0 314 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.627 71.5379C78.7389 71.5379 44.9638 50.3787 21.8487 71.5379C-3.9624 95.165 28.1942 112.433 28.1942 150.852C28.1942 184.857 -9.29882 223.227 21.8488 241.338C52.9964 259.449 71.0486 222.753 116.167 222.753C157.587 222.753 155.092 240.428 199.007 252.302C270.868 271.732 313.785 243.837 313.785 213.442C313.785 183.048 261.256 165.731 286.837 124.336C321.811 67.7422 298.005 32 253.498 32C204.707 32 194.515 71.5379 136.627 71.5379Z",
    fill: "#DEE9FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.811,
    y: 51.5547,
    width: 119.189,
    height: 184.743,
    rx: 4,
    fill: "#347AF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 44.7441,
    width: 119.189,
    height: 184.743,
    rx: 4,
    fill: "#A9C9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.974 55.8115H123.217V205.649H221.974V55.8115Z",
    fill: "#4B87F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.162 101.609H130.027V120.339H215.162V101.609Z",
    fill: "#A9C9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.162 127.15H130.027V145.88H215.162V127.15Z",
    fill: "#A9C9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.162 152.689H130.027V171.419H215.162V152.689Z",
    fill: "#A9C9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.783 217.569C165.783 221.33 168.833 224.379 172.594 224.379C176.356 224.379 179.405 221.33 179.405 217.569C179.405 213.807 176.356 210.758 172.594 210.758C168.833 210.758 165.783 213.807 165.783 217.569Z",
    fill: "#347AF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 164.273,
    width: 63.4377,
    height: 63.4377,
    rx: 31.7189,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251.22 210.31C252.836 210.31 254.157 208.988 254.157 207.373H248.283C248.283 208.988 249.605 210.31 251.22 210.31ZM260.031 201.499V194.157C260.031 189.649 257.638 185.875 253.423 184.876V183.878C253.423 182.659 252.439 181.675 251.22 181.675C250.002 181.675 249.018 182.659 249.018 183.878V184.876C244.818 185.875 242.41 189.634 242.41 194.157V201.499L239.473 204.436V205.905H262.968V204.436L260.031 201.499ZM257.094 202.968H245.347V194.157C245.347 190.515 247.564 187.549 251.22 187.549C254.877 187.549 257.094 190.515 257.094 194.157V202.968Z",
    fill: "#266EF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.281 84.9307H60.2168C58.0077 84.9307 56.2168 86.7215 56.2168 88.9307V120.579V135.622C56.2168 138.837 59.8189 140.739 62.4738 138.924L74.9662 130.386C75.6311 129.932 76.4154 129.689 77.2208 129.689C79.3032 129.689 83.7519 129.689 88.4733 129.689C128.015 129.689 163.421 129.689 175.014 129.689C177.223 129.689 179 127.898 179 125.689V120.579V93.615V88.9307C179 86.7215 177.209 84.9307 175 84.9307H165.281Z",
    fill: "#A9C9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.065 77.7148H53C50.7909 77.7148 49 79.5057 49 81.7148V113.363V128.406C49 131.622 52.6021 133.523 55.257 131.708L67.7494 123.17C68.4143 122.716 69.1986 122.473 70.004 122.473C72.0864 122.473 76.5351 122.473 81.2565 122.473C120.798 122.473 156.204 122.473 167.797 122.473C170.006 122.473 171.783 120.682 171.783 118.473V113.363V86.3992V81.7148C171.783 79.5057 169.992 77.7148 167.783 77.7148H158.065Z",
    fill: "#347AF3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M163.458 86.0381H57.3242V94.3623H163.458V86.0381Z",
    fill: "#A9C9FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M163.458 102.689H86.459V111.014H163.458V102.689Z",
    fill: "#A9C9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/emptyState.b675163f649496b1a1237d15a798eb28.svg";
export { ForwardRef as ReactComponent };